import { FundriseRouteConfig } from 'vue-router';

const marketingRedirectRoutes: Array<FundriseRouteConfig> = [
	{
		path: '/pro',
		name: 'pro',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		redirect: { name: 'home' }
	}
];

export default marketingRedirectRoutes;
